import Todo from "../../img/Project/Todo.png";
import Kryptic from "../../img/Project/Kryptic.png";
import Architect from "../../img/Project/Architect.png";
import pet from "../../img/Project/pet.png";
import Shopz1 from "../../img/Project/shopz1Home.png";


const ProjectsInfo = [
  {
    title: [
      "Ecommerce",
      "SalesCaption",
      "KnightBite",
       "PetsHub",
      "Netflix Redesign",
      
    ],
    info: [
      "Built an e-commerce website using React.js, delivering a user- friendly interface, intuitive navigation,C and essential functionalities like product showcasing, cart management, and secure checkout",
      "Harnessing the power of ReactJS, our website redefines sales management. Experience the cutting-edge, responsive design and lightning-fast performance, making sales a breeze with SalesCaption",
      "A captivating website crafted with HTML, CSS, and Bootstrap. Explore the intersection of design and functionality as we bring your culinary adventures to life through a visually stunning and user-friendly experience",
      "The Pet Hub Website is a delightful and functional web project designed for pet lovers and enthusiasts. Crafted with HTML, CSS, and JavaScript, this static website serves as an online hub for all things related to our furry friends. The website combines eye-catching design with practical features to provide an engaging user experience.",
      "Netflix Redesign: A stunning HTML, CSS, and Bootstrap creation that reimagines the Netflix interface. Dive into a sleek, user-friendly design and enjoy a visually immersive streaming experience with this dynamic website project",
      // "An elegantly designed web-based digital clock built with HTML5, JavaScript, and CSS. This project showcases real-time precision, displaying the current date, month, and year in a visually appealing and functional manner",
      
    ],
    github: [
      "https://github.com/Akshatha2023/eCommerceShop_Reactjs",
      "https://github.com/Akshatha2023/SalesCaption_Website",
      "https://github.com/Akshatha2023/KnightBite_Website",
      "https://github.com/Akshatha2023/Pet_Website",
      "https://github.com/Akshatha2023/Netflix_Website",
      // "https://github.com/Akshatha2023/Digital-Cock-Application-With-Present-Date-Month-and-Year",
     
    ],
    liveDemo: [
      "https://comfy-akshathaecommerce.netlify.app/ ",
      " https://akshathasales.netlify.app/",
      "https://akshathaknightbite.netlify.app/",
      "https://akshathapet.netlify.app/",
      "https://github.com/Akshatha2023/Netflix_Website",
      // "https://akshathacurrentdatetimemonth.netlify.app/",
     
    ],
    stack: [
      ["React","Router","UseState", "Redux" ,"Tailwind","Nodejs","Rest Api"],
      ["React", "UseState", "Router", "HTML", "CSS", "Javascript", "Tailwind"],
      [ "HTML", "CSS", "Javascript", "Bootstrap"],
      ["HTML", "CSS", "Javascript","Bootstrap"],
      ["HTML", "CSS", "Javascript","Bootstrap"],
      // ["HTML", "CSS", "Javascript"],
    ],
    date: [
      "JAN 2023",
      "AUG 2022",
      "AUG 2022",
      "JUN 2022",
      "Feb 2023",
     
      
    ],
    thumbnail: [ Todo, Kryptic, Architect,pet,Shopz1],
    // imgages: [
    // ]
  },
];

export default ProjectsInfo;
